import feathersClient, {makeServicePlugin, BaseModel} from '../../feathers-client'

class EventHome extends BaseModel {
    constructor(data, options) {
        super(data, options)
    }

    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'EventHome';

    // Define default properties here
    static instanceDefaults() {
        return {
            eventId: null,
            html_styles: '',
            html_content: '',
            banner: null,
        }
    }
}

const servicePath = 'f-home';
const servicePlugin = makeServicePlugin({
    Model: EventHome,
    service: feathersClient.service(servicePath),
    servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    }
});

export default servicePlugin
